import React from "react";

function Header(){
    return (
        <div className="border shadow-lg py-3 fixed w-full bg-white top-0">
            <div className="text-3xl font-bold underline flex justify-center ">Arjun Blogs</div>
        </div>
        
    );
}
export default Header;